/**
 * Client runtime configuration.
 *
 * CRA inlines REACT_APP_* at BUILD time, so the deployed bundle's API URL is
 * fixed when `npm run build` runs — an App Service app setting cannot change it
 * afterwards.
 *
 * The default is the RELATIVE "/api". When the client is served from the same
 * App Service as the server (Stage 8), a relative base resolves against whatever
 * origin served the page, so:
 *   - the same build works in any environment (no per-environment rebuild), and
 *   - there is no cross-origin request, so CORS never enters the picture.
 *
 * Local dev sets REACT_APP_API_URL=http://localhost:5000/api in client/.env,
 * because there the API is a separate process on a different port.
 */
export const API_BASE = process.env.REACT_APP_API_URL || '/api';

// Files (uploads, QR codes) are served from the API host but off the /api path,
// so strip a trailing /api. With the relative default this becomes '' — a
// same-origin absolute path like /uploads/... — which is exactly what we want.
export const FILE_BASE = API_BASE.replace(/\/api\/?$/, '');
